import Command from '@ckeditor/ckeditor5-core/src/command';

var dataContent;
export default class NewsInTextTwoCommand extends Command {
    execute() {
        const selectUrl  = prompt( 'Укажите ссылку на материал' );
        if(selectUrl === null || selectUrl === ''){
            return writer.createElement('paragraph');
        }
        axios.post('/getMetaParams', {
            url: selectUrl
        }).then(function (response){
            dataContent = response.data;
        });
        setTimeout(function (){
            editor_text.model.change(writer => {
                editor_text.model.insertContent(createNewsInTextTwo(writer));

            });
        },1000)

    }

    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'insertBoxTwo');
        this.isEnabled = allowedIn !== null;
    }
}

function createNewsInTextTwo(writer) {
    let url = dataContent.url;
    const NewsInTextTwoBox = writer.createElement('insertBoxTwo', {'data-href': url });
    const NewsInTextTwoTitle = writer.createElement('insertTitleTwo');
    const NewsInTextTwoText = writer.createElement('insertTextTwo');
    const innerTitle = writer.createText(dataContent.title);
    const innerText = writer.createText('В ТЕМУ:');
    writer.append(innerTitle, NewsInTextTwoTitle);
    writer.append(innerText, NewsInTextTwoText);
    writer.append(NewsInTextTwoText, NewsInTextTwoBox);
    writer.append(NewsInTextTwoTitle, NewsInTextTwoBox);
    return NewsInTextTwoBox;
}
